import { Component } from '@angular/core';

@Component({
  selector: 'lego-menu',
  template: '<ng-content></ng-content>'
})
export class MenuComponent {
}
